export default {
	transactions_table_client_id: 'Client ID',
	transactions_table_created_at: 'Timestamp',
	transactions_table_date_paid: 'Timestamp',
	transactions_table_id: 'Request number',
	transactions_table_invoice_id: 'Invoice ID',
	transactions_table_type: 'Type',
	transactions_table_card_number: 'Address',
	transactions_table_amount_total: 'Amount',
	transactions_table_fee: 'Fee',
	transactions_table_amount_credited: 'Amount to be credited',
	transactions_table_status: 'Status',
	transactions_table_resolution: 'Solution',
	transactions_table_tg_user: 'Telegram Username',
	transactions_filter_telegram_username: 'Telegram Username',
	transactions_filter_created_at: 'Transactions Date',
	transactions_table_payment_system: 'Payment system',
	transactions_table_method: 'Method',
	
	transaction_title: 'Request',
	transaction_client_id: 'Client ID',
	transaction_id: 'Request number',
	transaction_invoice_id: 'Invoice ID',
	transaction_type: 'Type',
	transaction_status: 'Status',
	transaction_card_number: 'Address',
	transaction_amount_total: 'Amount',
	transaction_fee: 'Fee',
	transaction_amount_credited: 'Amount to be credited',
	transaction_commission_refund: 'Commission refund',
	transaction_financial_manager: 'Financial manager',
	transaction_resolution: 'Solution',
	transaction_resolution_popup_title: 'Confirm changes to the request',
	transaction_resolution_popup_text: 'You are confirming the change of solution from :currentValue to :newValue',
	transaction_btn_cancel: 'Cancel',
	transaction_btn_confirm: 'Confirm',
	transaction_tg_user: 'Telegram Username',
	transaction_created_at: 'Timestamp',
	
};